import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

export interface MachineServiceToggleProps {
	readonly label: React.ReactNode;
	readonly checked: boolean;
	readonly onChange: () => void;
}

export const MachineServiceToggle: React.FC<MachineServiceToggleProps> = ({ label, checked, onChange }) => (
	<Stack alignItems="center" spacing={1}>
		<Typography variant="h4">{label}</Typography>
		<ToggleButtonGroup
			exclusive
			value={checked ? "on" : "off"}
			onChange={(_, value: string | null) => {
				if (value !== null) {
					onChange();
				}
			}}
			sx={{ width: "100%" }}
		>
			<ToggleButton value="off" color="error" sx={{ flex: 1, gap: 1 }}>
				<CancelIcon />
				<FormattedMessage id="Off" defaultMessage="Off" />
			</ToggleButton>

			<ToggleButton value="on" color="success" sx={{ flex: 1, gap: 1 }}>
				<CheckCircleIcon />
				<FormattedMessage id="On" defaultMessage="On" />
			</ToggleButton>
		</ToggleButtonGroup>
	</Stack>
);
